import React from 'react';

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategorySelect: (category: string) => void;
  className?: string;
}

/**
 * CategoryFilter - Category filtering for Agent Discovery Hub
 * Part of MVP-UX-002: Agent Discovery Hub
 */
export function CategoryFilter({ 
  categories, 
  selectedCategory, 
  onCategorySelect, 
  className = '' 
}: CategoryFilterProps) {
  // Task-focused category labels
  const getCategoryLabel = (category: string) => {
    const labels: Record<string, string> = {
      'all': 'All Tasks',
      'intelligence': '🔍 Research & Analysis',
      'content': '✍️ Content Creation',
      'optimization': '📈 Optimization',
      'automation': '⚡ Automation',
      'analytics': '📊 Analytics & Reports'
    };
    return labels[category] || category.charAt(0).toUpperCase() + category.slice(1);
  };

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {categories.map(category => (
        <button
          key={category}
          onClick={() => onCategorySelect(category)}
          className={`
            px-4 py-2 rounded-full text-sm font-medium
            transition-all duration-200
            ${
              selectedCategory === category
                ? 'bg-blue-500 text-white shadow-md'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
            }
          `}
        >
          {getCategoryLabel(category)}
        </button>
      ))}
    </div>
  );
}